// extracted by mini-css-extract-plugin
module.exports = {"selScreen":"SelScreen_selScreen__3fos3"};